import { ENG, CH } from "../../constants"

let dictionary = {}

dictionary[ENG] = {
    TITLE: "Education",
    PERIOD1: "09/2019 - 07/2021",
    EDUCATION_TITLE1: "National Taiwan University, Master Degree",
    EDUCATION_SUBTITLE1: "Department of Computer Science and Engineering",
    DESC1:
        "Specialized in artificial intelligence, machine learning, deep learning, and natural language processing in iAgent Lab.",
    PERIOD2: "03/2018 - 08/2018",
    EDUCATION_TITLE2: "Ruhr University Bochum (Germany)",
    EDUCATION_SUBTITLE2: "Exchange Student",
    DESC2:
        "Got to understand the thoughts and perspectives from people around the world and made friends from different countries such as German, Italy, India, Korea, etc. Improved English and German by taking courses and attending workshop.",
    PERIOD3: "06/2013 - 03/2018",
    EDUCATION_TITLE3: "National Taiwan University, Bachelor Degree",
    EDUCATION_SUBTITLE3: "Department of Materials Science and Engineering",
    DESC3:
        "Developed the interest in Computer Science. Got grade of A (4.0 / 4.3 ) in Interactive Web Programming course. Developed a web prototype of a platform in User Experience Course and got grade of A+ ( 4.3 / 4.3 )."
}

dictionary[CH] = {
    TITLE: "學習歷程",
    PERIOD1: "09/2019 -",
    EDUCATION_TITLE1: "國立台灣大學",
    EDUCATION_SUBTITLE1: "資訊工程研究所",
    DESC1:
        "加入許永真教授智慧代理實驗室，主攻人工智慧與機器學習。碩一研究題目為假新聞的判斷與偵測，以深度學習的模型判斷新聞文章真偽。也參與中研院「 以 AI 打造網路社群媒體安心使用環境」計畫。",
    PERIOD2: "03/2018 - 08/2018",
    EDUCATION_TITLE2: "德國魯爾波鴻大學",
    EDUCATION_SUBTITLE2: "交換學生",
    DESC2:
        "交換期間努力和不同文化背景的人交流，了解不同國家的思維與價值觀，結交了來自義大利、韓國、印度與德國等好朋友。透過修課、工作坊增進英文與德文語言能力，曾試著以全英文求職，並拿到面試機會。",
    PERIOD3: "06/2013 - 03/2018",
    EDUCATION_TITLE3: "國立台灣大學",
    EDUCATION_SUBTITLE3: "材料科學與工程學系",
    DESC3:
        "在校期間發覺對資訊工程的興趣，修習過資料結構、演算法、計算機網路等十門以上資工領域基礎課程，平均等第為 A- (GPA: 3.7 /4.3) ，也在機器學習、使用者經驗設計、網頁互動程式設計等應用課程拿下 A 等第(4.0 / 4.3) 以上成績"
}

export default dictionary
